import { z } from 'zod'

import { type Preset, PRESETS } from './period'

/**
 * The Dashboard's search: the date range preset, in the address so a view can be bookmarked or
 * shared. Anything unreadable is dropped, which leaves the default (the last 30 days).
 */
export const dashboardSearchSchema = z.object({
  range: z
    .enum(PRESETS.map((preset) => preset.key) as [Preset, ...Preset[]])
    .optional()
    .catch(undefined),
})

export type DashboardSearch = z.infer<typeof dashboardSearchSchema>
